/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import {
  RECEIVED_BUCKET_ROLL
} from './BucketRollActions';

export const bucketRollReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIVED_BUCKET_ROLL:
      return { endDate: action?.bucketRollData?.date }
    default:
      return state;
  }
};
